"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Pill = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
var PillTheme = {
  "pill": "PillTheme__pill__3Q4KS"
}; 
require('./PillTheme.css');
var DisabledPillTheme = {
  "pill": "DisabledPillTheme__pill__2CfB5"
}; 
require('./DisabledPillTheme.css');
var ExternalTeamPill = function ExternalTeamPill(_ref) {
  var _ref$hasBeenShared = _ref.hasBeenShared,
    hasBeenShared = _ref$hasBeenShared === void 0 ? false : _ref$hasBeenShared;
  return /*#__PURE__*/_react.default.createElement(_Pill.default, {
    disabled: true,
    theme: hasBeenShared ? DisabledPillTheme : PillTheme
  }, "EXTERNAL");
};
ExternalTeamPill.propTypes = {
  hasBeenShared: _propTypes.default.bool.isRequired
};
var _default = exports.default = ExternalTeamPill;
//# sourceMappingURL=ExternalTeamPill.js.map